export var EventAction;
(function (EventAction) {
    EventAction["Filter"] = "filter";
    EventAction["Navigation"] = "navigation";
    EventAction["Content"] = "content";
    EventAction["Internal_Link"] = "internal_link";
    EventAction["View_Change"] = "view_change";
})(EventAction || (EventAction = {}));
export var ActiveTabKeys;
(function (ActiveTabKeys) {
    ActiveTabKeys["standardEquipment"] = "standard equipment layer";
    ActiveTabKeys["technicalData"] = "technical data layer";
})(ActiveTabKeys || (ActiveTabKeys = {}));
